export const Endpoint = 'continuity/people/lookup-person-by-name';
export const Method = 'GET';
